import styled from "styled-components";

export const Div = styled.div`
  float: left;
`;
export const Div2 = styled.div`
  float: left;
  margin-left: 5px;
`;
export const newActionsDiv = styled.div`
  margin-right: 0.1em;
`;
export const Span = styled.span`
  color: #5d687e;
  float: left;
`;
export const Info = styled.span`
  color: #5d687e;
  font-size: 10px;
`;

export const OrangeSpan = styled.span`
  color: #e54f17;
`;

export const RedBorderSpan = styled.span`
  border: 1px solid #e54f17;
  border-radius: 50%;
  min-width: 24px;
  display: inline-block;
  text-align: center;
  color: #b71c1c;
  line-height: 24px;
  float: left;
`;

export const GreenBorderSpan = styled.span`
  border: 1px solid #1faa00;
  border-radius: 50%;
  min-width: 24px;
  display: inline-block;
  text-align: center;
  color: #1faa00;
  line-height: 20px;
  min-height: 24px;
  float: left;
`;

export const YellowBorderSpan = styled.span`
  border: 1px solid rgb(251, 192, 45);
  border-radius: 50%;
  min-width: 24px;
  display: inline-block;
  text-align: center;
  color: rgb(251, 192, 45);
  line-height: 20px;
  float: left;
`;

export const I = styled.i`
  color: #1faa00;
  float: left;
`;
